import { Outlet } from 'react-router-dom';

/**
 * Layout per le pagine di autenticazione (login, reset password, etc.)
 */
function AuthLayout() {
  return (
    <div 
      className="min-h-screen min-h-[100dvh] flex flex-col bg-gradient-to-br from-primary/5 via-background to-secondary/10"
      style={{
        minHeight: '-webkit-fill-available',
      }}
    >
      {/* Header minimo */}
      <header 
        className="p-3 sm:p-4"
        style={{
          paddingTop: 'max(0.75rem, env(safe-area-inset-top))',
          paddingLeft: 'max(0.75rem, env(safe-area-inset-left))',
          paddingRight: 'max(0.75rem, env(safe-area-inset-right))',
        }}
      >
        <div className="container mx-auto">
          <h1 className="text-lg sm:text-xl font-bold text-primary">Portale Famiglia</h1>
        </div>
      </header>

      {/* Contenuto principale */}
      <main 
        className="flex-1 flex items-center justify-center p-3 sm:p-4"
        style={{
          paddingLeft: 'max(0.75rem, env(safe-area-inset-left))',
          paddingRight: 'max(0.75rem, env(safe-area-inset-right))',
        }}
      >
        <div className="w-full max-w-md">
          <Outlet />
        </div>
      </main>

      {/* Footer */}
      <footer 
        className="p-3 sm:p-4 text-center text-xs sm:text-sm text-muted-foreground"
        style={{
          paddingBottom: 'max(0.75rem, env(safe-area-inset-bottom))',
        }}
      >
        <p>&copy; {new Date().getFullYear()} Casa di Riposo - Tutti i diritti riservati</p>
      </footer>
    </div>
  );
}

export default AuthLayout;
